import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

import type { Reaction } from "./utils";

interface EntityReactionsProps {
  reactions: Reaction[];
  className?: string;
}

export function EntityReactions({ reactions, className }: EntityReactionsProps) {
  if (reactions.length === 0) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={200}>
      <div className={cn("flex flex-wrap gap-1", className)}>
        {reactions.map((reaction) => (
          <Tooltip key={reaction.id}>
            <TooltipTrigger asChild>
              <span
                className="cursor-default rounded-full bg-gray-100 px-2 py-1 text-xl"
                aria-label={`${reaction.userName} reacted with ${reaction.emoji}`}
              >
                {reaction.emoji}
              </span>
            </TooltipTrigger>
            <TooltipContent>{reaction.userName}</TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
}
